import Vue from 'vue'

export default {
  token: 'token123',
  locationHref: location.protocol + '//' + location.hostname + '/',
  mobileAPI: 'api/v1/',
  // 屬於自定 function
  install () {
    // 取得網址查詢資訊
    Vue.prototype.getSearch = function () {
      var strUrl = location.search // 取得網址
      var getPara, ParaVal // 宣告
      var aryPara = [] // 陣列宣告
      if (strUrl.indexOf('?') !== -1) {
        var getSearch = strUrl.split('?') // 分割 ?
        getPara = getSearch[1].split('&') // 分割 &
        for (var i = 0; i < getPara.length; i++) { // 打印 for 迴圈
          ParaVal = getPara[i].split('=') // 最後在分割 =
          // aryPara.push(ParaVal[0]); // 打印 開頭
          aryPara[ParaVal[0]] = ParaVal[1] // 打印 參數
        }
      }
      return [strUrl, aryPara]
    }

    // AJAX 套件
    Vue.prototype.AjaxData = function ($url, $method, $dataType, $data = '') {
      var $text = ''
      var $form = $('form')
      var formata = new FormData($form[0])
      if ($method === '') { $method = 'POST' }

      if ($method === 'GET') {
        var $search = this.getSearch()
        var $customize = $search[0]
        if ($url.indexOf('?') !== -1) {
          if ($customize !== '') {
            $customize = '&' + $customize.substr(1)
          }
        }
        $url += $customize
      }
      // console.log('suite ->', $data)
      // ajax 相關資料整理
      var $ajaxJson = {
        url: $url,
        type: $method,
        async: false, // 啟用同步請求
        cache: true,
        dataType: $dataType
      }

      if ($data !== '') {
        $ajaxJson['data'] = $data
        $ajaxJson['tradition'] = true
      } else {
        $ajaxJson['data'] = formata
        $ajaxJson['contentType'] = false
        $ajaxJson['processData'] = false
        // $ajaxJson['crossDomain'] = true
      }

      $ajaxJson['success'] = function (msg) { $text = msg }
      $ajaxJson['error'] = function (xhr, ajaxOptions, thrownError) {
        $text = xhr.status + '<br/>' + thrownError
      }

      $.ajax($ajaxJson)
      return $text
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/suite.js